import { PlasmError } from "./PlasmError";
export class PlasmIntegrationError extends PlasmError {
    constructor() {
        super(...arguments);
        this.name = "PlasmIntegrationError";
    }
}
